var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RoleDetailEdit',_vm._b({on:{"set-subtype":function($event){return _vm.$emit('set-subtype', $event)}}},'RoleDetailEdit',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }